"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YEAR_MINS = exports.DAY_MINS = exports.DAY_MS = exports.HOUR_MS = exports.MINUTE_MS = exports.DAY_S = exports.HOUR_S = exports.YEAR_DAYS = exports.DAY_HOURS = exports.HOUR_MINS = exports.MINUTE_S = exports.SECOND_MS = void 0;
exports.SECOND_MS = 1000;
exports.MINUTE_S = 60;
exports.HOUR_MINS = 60;
exports.DAY_HOURS = 24;
exports.YEAR_DAYS = 365;
exports.HOUR_S = exports.MINUTE_S * exports.HOUR_MINS;
exports.DAY_S = exports.HOUR_S * exports.DAY_HOURS;
exports.MINUTE_MS = exports.SECOND_MS * exports.MINUTE_S;
exports.HOUR_MS = exports.MINUTE_MS * exports.HOUR_MINS;
exports.DAY_MS = exports.HOUR_MS * exports.DAY_HOURS;
exports.DAY_MINS = exports.HOUR_MINS * exports.DAY_HOURS;
exports.YEAR_MINS = exports.DAY_MINS * exports.YEAR_DAYS;
//# sourceMappingURL=time.js.map